import React from 'react';
import pic from '../../assets/images/terminal.png';

const TerminalIcon = () => (
  <img
    src={pic}
    alt="Terminal Icon"
    style={{
      width: '100%',
      height: 'auto', // Maintain aspect ratio
      objectFit: 'contain',
      display: 'block', // Ensure it behaves like a block element
    }}
  />
);

export default TerminalIcon;
